import React, { useEffect, useRef, useState } from "react";
import Background from "../BackGround/background";
import { Link, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import OtpInput from "react-otp-input";
import { useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import flowBackEndServices2 from "../../services/flowBackendServices";
import {
  loginEvent,
  setEmailAndMobile,
  setNewUser,
  setOtpData,
  setOTPVerified,
  setUser,
  updateAuthTokenForSession,
} from "../../slices/authReducer";
import { toast } from "react-toastify";
import refresh from "../../assets/images/refresh-circle.svg";
import Timer from "../common/timer";
import { getBrowserDetails } from "../../comman/status";
import { QUERY_PARAM } from "../../utils/config";
import authService from "../../services/authService";
import RiskDisclosure from "./RiskDisclosure";

import { RootState } from "../../store";
import { getExtraQueryparam, scopeParse } from "../common/parseQueryParam";
import {
  VerifyMfaPayload,
  VerifyMfaResponse,
  VerifyMfaSSOResponse,
} from "../../models/login";
import { t } from "../../utils/appString";



import KYC_M_mobile from "../../assets/images/KYC_mobile.svg";
import KYC_M_Download from "../../assets/images/KYC_download_app.svg";
import { ReactComponent as Tick } from "../../assets/icons/tick-circle.svg";

const loginOTPVerify: React.FC = () => {
  const [kra, setKra] = useState<number>(0);
  const navigate = useNavigate();
  const { data, themeData } = useSelector((state: RootState) => state.authUser);
  const [aeroUrl, setAeroUrl] = useState<string | null>(null);

  const [Otp, setOtp] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingResed, setIsLoadingResed] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [showNext, setShowNext] = useState(false);
  const [showDot, setShowDot] = useState(false);
  const [isKyc, setIsKyc] = useState(false);
  // const [displayMode, setDisplayMode] = useState<string>("totp");

  const [show, setShow] = useState(false);
  const [showResetBtn, setShowResetBtn] = useState(false);
  const [otpType, setOtpType] = useState("otp");
  const [isPermissionGranted, changePermissionGrant] = useState<boolean>(false);
  const [kycURL, setKYCURL] = useState<string>("");
  const otpInputRef = useRef<any>(null);
  const tvTerminalId = process.env.REACT_APP_TV_APPLICATION_ID

  // var isPermissionGranted = false;

  // function changePermissionGrant(val) {
  //     console.log(val)
  //     isPermissionGranted = val;
  // }

  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  const [forceOtpType, setForceOtpType] = useState<null | "otp" | "totp">(null);

  const handleResize = () => {
    setIsDesktop(window.innerWidth > 768);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (data && forceOtpType === null) {
      if (data.data) {
        const isOTPOrTOTP =
          data.data.next === "existing_client_totp"
            ? "totp"
            : data.data.next === "existing_client_otp"
            ? "otp"
            : "otp";
        setOtpType(isOTPOrTOTP);
      } else {
        const isOTPOrTOTP =
          data.next === "existing_client_totp"
            ? "totp"
            : data.next === "existing_client_otp"
            ? "otp"
            : "otp";
        setOtpType(isOTPOrTOTP);
      }
    }
  }, [data, forceOtpType]);

  useEffect(() => {
    if (data === null) {
      localStorage.removeItem("useRefresh")
    }
    if (!data?.token) {
      navigate("/", { replace: true });
    }
  }, []);

  useEffect(() => {
    if(!themeData || Otp.length !== 6 || themeData.permission_needed) return
    // Trigger request when OTP length becomes 6
    if(Otp.length === 6 && !themeData.permission_needed) {
      handleOnClick() // Call the function without passing the event
    }
  }, [Otp, themeData, isPermissionGranted]);

  useEffect(() => {
    const handleClick = () => {
      setTimeout(() => {
        const otpLength = otpInputRef.current.props.value.length; // Use state variable Otp to determine length
        otpInputRef.current?.focusInput(otpLength); // Focus on the next empty input
      }, 0);
    };
  
    document.addEventListener('click', handleClick);
  
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  // useEffect(() => {
  //   // Always send OTP if backend says next is existing_client_otp
  //   if (
  //     (data && data.data && data.data.next === "existing_client_otp") ||
  //     (data && data.next === "existing_client_otp")
  //   ) {
  //     // sendToptSMS();
  //   }
  //   // eslint-disable-next-line
  // }, [data]);
  

  const showResend = () => {
    setShowResetBtn(!showResetBtn);
  };

  function resendPassword() {
    sendToptSMS();
    showResend();
  }

  function setPermission() {
    changePermissionGrant(!isPermissionGranted);
  }

  function handleOnClick() {
    firstFactor();
  }

  function firstFactor() {
    const { deviceId, token: tempToken } = data;
    const effectiveOtpType = forceOtpType || otpType;
    let mfaType = effectiveOtpType;

    let browswe = getBrowserDetails();
    let deviceInfo = `${browswe?.browserName}`;
    let appVersion = `${browswe?.fullVersion}`;
    let os = `${browswe?.OSName}`;

    let dataSend: VerifyMfaPayload = {
      otp: `${Otp}`,
      deviceId: deviceId,
      mfaType,
      deviceInfo,
      appVersion,
      os,
    };
    setIsLoading(true);
    flowBackEndServices2
      .firstFactor(dataSend, tempToken)
      .then((value) => {
        if (value?.status === 200) {
          dispatch(setOTPVerified()) // TRUE
          let response = value.data;
          if (response.status === "success") {
            const isRefreshFlow = localStorage.getItem("useRefresh");
            if (isRefreshFlow && (!themeData || themeData.applicationId === tvTerminalId)) {
              navigate("/ResetMPin", { replace: true });
              localStorage.removeItem("useRefresh");
            }
            else{
            // "existing_client_password" ==>   || existing_client_reset_password ==> FlowCreateNewPassword
            if (response.next === "existing_client_password") {
              navigate("/mpin-redirection", { replace: true });
            } else if (response.next === "existing_client_reset_password") {
              // navigate(t("routes.resetPassword"), { replace: true });
            }
            // TODO: Existing USER MPIN
            else if (response.next === "existing_client_mpin") {
              // setting the user
              const tempUserData = { user_name: response.name } as any;
              dispatch(setUser(tempUserData));
              // OLD User must be logged in
              navigate(t("routes.mPin"), { replace: true });
            } else if (response.next === "kyc") {
              setIsKyc(true);
              const finalURL = `https://accounts.rupeezy.in/authentication/ssoverification?token=${response?.refresh_token}`;
              setKYCURL(finalURL);
              window.open(finalURL, '_self')
            } else if (response.next === "existing_client_reset_mpin") {
              // store new user
              dispatch(setNewUser(true));
              navigate(t("routes.mpInSet"), { replace: true });
            }
          }
            dispatch(updateAuthTokenForSession({ data: value.data.token }));
            // setUpSessionData(response, dispatch, data,mfaType)
          } else {
            toast.error(`${response.message}`);
          }
        }
      })
      .catch((reason) => {
        console.error(reason);
        setIsLoading(false);
      })
      .finally(() => {setIsLoading(false);});
  }

  function redirect(token: string) {
    const finalURL = `https://accounts.rupeezy.in/authentication/ssoverification?token=${token}`;
    window.open(finalURL, "_self");
  }

  function returnKyc() {
    if (isDesktop) {
      return (
        <React.Fragment>
          <div className="disclosureLayer"></div>
          <div className="disclosure-2">
            {/* {<KycRedirect redirectUrl=s{kycURL}></KycRedirect>} */}
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div className="disclosureLayer"></div>
          <div
            style={{ width: "100%", maxHeight: "100%"}}
            className="disclosure-2"
          >
            <div style={{width: '100%'}} className="d-flex flex-column ">
              <div
                style={{
                  backgroundColor: "#171D27",
                  opacity: 0.5,
                }}
                className="flex-grow-1  d-flex"
              ></div>

              <div style={{ borderRadius: 10 }} className="">
                {/* Headers */}
                <div
                  style={{
                    fontSize: 18,
                    lineHeight: "24px",
                    fontWeight: 600,
                    color: "#171D27",
                    backgroundColor: "#F6F8FC",
                    borderRadius: 10
                  }}
                  className="px-2 py-4"
                >
                  Your account is under review
                </div>

                {/* Body */}
                <div
                  style={{
                    color: "#064AD3",
                    fontWeight: 700,
                    fontSize: 24,
                    lineHeight: "30px",
                  }}
                  className="bg-white px-2 py-4"
                >
                  Download the Rupeezy app and explore Smart Trading feature in
                  Guest Mode
                </div>

                <div
                  style={{ fontWeight: 600 }}
                  className="discPointers px-2 py-3"
                >
                  <div className="pointers-flex">
                    <div style={{ height: 24, width: 24 }}>
                      <Tick />
                    </div>
                    <div style={{ color: "#171D27" }} className="pl-3">
                      Suite of smart features{" "}
                      <span style={{ color: "#064AD3" }}>
                        GTT+OCO, Iceberg and AMT order
                      </span>
                    </div>
                  </div>

                  <div className="d-flex py-4">
                    <div style={{ height: 20, width: 20 }}>
                      <Tick />
                    </div>
                    <div style={{ color: "#171D27" }} className="pl-3">
                      <span style={{ color: "#064AD3" }}>Zero charges</span> for
                      account opening, delivery trades, Pay later @10.99%
                    </div>
                  </div>
                </div>

                <div
                  style={{ fontWeight: 600 }}
                  className="row justify-content-between align-items-center pt-4 px-4"
                >
                  <div className="col-4">
                    <Link to="/login">
                      <img src={KYC_M_Download} alt="kyc download app" />
                    </Link>
                  </div>
                  <div className="col-8">
                    <img
                      style={{ width: "100%" }}
                      src={KYC_M_mobile}
                      alt="kyc download app"
                    />
                  </div>
                </div>

                <div
                  style={{ cursor: "pointer" }}
                  className="px-2"
                >
                  <a
                    className="blue_btn w-100 mb-3 btn btn-primary"
                    href="https://rupeezy.onelink.me/ZU5D/4eo9zgez"
                    target="_self"
                  >
                    Complete your KYC
                  </a>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }

  function verifyMfaSSO() {
    const { deviceId, token: tempToken } = data;
    const effectiveOtpType = forceOtpType || otpType;
    let mfaType = effectiveOtpType;

    let browswe = getBrowserDetails();
    let deviceInfo = `${browswe?.browserName}`;
    let appVersion = `${browswe?.fullVersion}`;
    let os = `${browswe?.OSName}`;

    let dataSend: VerifyMfaPayload = {
      otp: `${Otp}`,
      deviceId: deviceId,
      mfaType,
      deviceInfo,
      appVersion,
      os,
    };
    setIsLoading(true);
    flowBackEndServices2
      .verifyMfaSSO(dataSend, tempToken)
      .then((value) => {
        if (value?.status === 200) {
          let response: VerifyMfaSSOResponse = value.data;
          if (value.data.status === "success") {
            // login event
            dispatch(
              setEmailAndMobile({
                mobile: response.mobile,
                email: response.email,
              })
            );
            dispatch(loginEvent());
            let fullRedirectUrl = response.redirectUrl + getExtraQueryparam();
            window.open(fullRedirectUrl, "_self");
          } else {
            toast.error(`${response.message}`);
          }
        }
      })
      .catch((reason) => {
        console.error(reason);
        setIsLoading(false);
      })
      .finally(() => setIsLoading(false));
  }

  function sendToptSMS() {
    const tempToken = data?.token;
    if (!tempToken) {
      navigate("/", { replace: true });
      return;
    }
    setIsLoadingResed(true);
    flowBackEndServices2
      .sendTOpt(null, tempToken)
      .then((value) => {
        if (value?.status === 200) {
          setOtp("");
          toast.success(`OTP sent`);
        }
      })
      .catch((reason) => {
        toast.error(`Failed`);
        setIsLoadingResed(false);
      })
      .finally(() => setIsLoadingResed(false));
  }

  function loginWithOTP() {
    const tempToken = data?.token;
    if (!tempToken) {
      navigate("/", { replace: true });
      return;
    }
    setIsLoadingResed(true);
    flowBackEndServices2
      .sendTOpt(null, tempToken)
      .then((value) => {
        if (value?.status === 200) {
          setOtp("");
          setForceOtpType("otp");
          toast.success(`OTP sent`);
          dispatch(updateAuthTokenForSession({ data: value.data.token }));
        }
      })
      .catch((reason) => {
        toast.error(`Failed`);
        setIsLoadingResed(false);
      })
      .finally(() => setIsLoadingResed(false));
  }

  // Add useEffect to handle OTP type changes
  useEffect(() => {
    if (otpType === "otp") {
      // Clear any existing OTP when switching to OTP mode
      setOtp("");
    }
  }, [otpType]);

  function setUpSessionData(
    value: VerifyMfaResponse,
    dispatch: any,
    data: any,
    mfaType: string
  ) {
    let userData = value;
    if (userData.status === "success") {
      let newData = { ...data, refreshToken: userData.refreshToken, mfaType };
      let dataSet = { data: newData, user_id: data.clientCode };
      dispatch(setOtpData(dataSet));
      toast.success(`OTP Verified`);
      const refreshData = {
        refreshToken: userData.refreshToken,
        ssoToken: userData.ssoToken,
        mfaType,
        deviceId: data.deviceId,
        tradingActive: userData.data?.tradingActive,
      };
      const userModify = { ...userData.data, ...refreshData };

      // login event
      dispatch(setEmailAndMobile({ mobile: null, email: userModify.email }));
      dispatch(loginEvent());

      authService.saveUserSessionFlow(userModify, refreshData, dispatch);
      if (userData.data.kra_status == "HOLD") {
        setShowNext(true);
        setKra(1);
        setShowDot(true);
      } else if (userData.data.kra_status == "REJECTED") {
        setShowNext(true);
        setKra(0);
        setShowDot(true);
      } else {
        setShowNext(false);
      }
      // if(mfaType === 'otp') navigate("/setTOtp",{ replace: true})
      // if(mfaType === 'totp')  navigate("/tvTerminal",{ replace: true});
    }
  }

  function acknowledge() {
    localStorage.setItem("acknowledge_disclosure", "false");
    sessionStorage.setItem("acknowledge_disclosure", "false");
    if (aeroUrl) {
      window.open(aeroUrl, "_self");
    } else {
      // we will navigate to the set passowrd here
      // navigate(t("routes.setPassword"), { replace: true });
      // if(otpType === 'otp') navigate("/setTOtp",{ replace: true})
      // if(otpType === 'totp')  navigate("/tvTerminal",{ replace: true});
    }
  }


  function Scope() {
    var scopeString = themeData.scope;
    var scopeArray = scopeString.split(",");
    return (
      <div className="permission_box" style={{ width: "100%" }}>
        <div
          style={{
            fontSize: "13px",
            alignItems: "flex-start",
            fontWeight: "bold",
          }}
          className="colorGrey pb-3"
        >
          You are about to grant the following permissions to {themeData.name}:
          <ul style={{paddingLeft: 16}}>
            {scopeArray.map((scope: any) => {
              var parsedScope = scopeParse(scope, scopeString);
              if (parsedScope && parsedScope != "") {
                return (
                  <li
                    className="permission-list-item"
                    style={{ fontWeight: "normal" }}
                  >
                    {parsedScope}
                  </li>
                );
              }
            })}
          </ul>
        </div>
        <label
          style={{ fontSize: "13px", alignItems: "flex-start" }}
          className="colorGrey pb-3"
        >
          <input
            type="checkbox"
            checked={isPermissionGranted} // Use 'checked' for controlling the state
            onChange={setPermission}
            style={{ marginRight: "3px" }}
          />
          I agree to give my account access to {themeData.name}
        </label>
      </div>
    );
  }
  const GotoLogin = () => {
    const isComingFromMpin = localStorage.getItem("PERSIST_OBJECT");

    if(isComingFromMpin){
      navigate("/Mpin", { replace: true });
      return;
    }
    localStorage.clear();
  
  // Also clear sessionStorage if needed
    sessionStorage.clear();
    
    // remove user data form redux store
    if (!themeData || themeData.applicationId === tvTerminalId) {
      navigate("/", { replace: true });
    }
    else {
      navigate(`/?applicationId=${themeData.applicationId}`, { replace: true });
    }
  };
  const effectiveOtpType = forceOtpType || otpType;
  return (
    <React.Fragment>
      <Background>
        <div className="h-100 d-flex card_padding flex-column justify-content-between align-items-center">
          <div className="py-2 align-self-start">
              <i onClick={GotoLogin} className="fas fa-arrow-left fas fa-lg" />
          </div>

          <div
            className="d-flex pb-3 pr-3 pl-3 flex-column justify-content-center align-items-center"
            style={{ width: "100%" }}
          >
            <h3 className="heading1 py-1 align-self-start">
              {effectiveOtpType?.toUpperCase()} Verification
            </h3>

            {effectiveOtpType === "otp" ? (
              <div
                style={{ fontSize: "13px" }}
                className="colorGrey align-self-start pb-3"
              >
                We have sent an OTP on your mobile & email. <br />
                Please enter the OTP here to complete the verification
              </div>
            ) : (
              <div
                style={{ fontSize: "13px" }}
                className="colorGrey align-self-start pb-3"
              >
                Use your authenticator app to generate 6-digit <br />
                TOTP and enter same here.
              </div>
            )}

            <OtpInput
              inputStyle="opt_box"
              ref={otpInputRef}
              value={Otp}
              onChange={setOtp}
              numInputs={6}
              isInputNum={true}
              isInputSecure={false}
              shouldAutoFocus={true}
              separator={<span />}
            />

            {themeData && themeData.permission_needed ? Scope() : ""}

            {effectiveOtpType === "otp" && (
              <div className="colorBlue align-self-start py-1">
                {showResetBtn ? (
                  <div className="d-flex flex-row c-pointer">
                    {isLoadingResed ? (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <span
                        className="4"
                        onClick={resendPassword}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <img src={refresh} alt={""} />
                        Resend OTP
                      </span>
                    )}
                  </div>
                ) : (
                  <div className="d-flex flex-row justify-content-start align-items-cente gap-2">
                    <div className="colorGrey">OTP can be resent in:</div>
                    <Timer
                      initialSeconds={59}
                      initialMinute={0}
                      showResend={showResend}
                    />
                  </div>
                )}
              </div>
            )}

            <Button
              disabled={
                isLoading ||
                Otp.length !== 6 ||
                (themeData.permission_needed && !isPermissionGranted)
              }
              className="blue_btn w-100 my-3"
              onClick={handleOnClick}
              variant="primary"
              type="submit"
            >
              {isLoading && (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              Verify {effectiveOtpType?.toUpperCase()} {themeData && themeData.permission_needed && "& Grant permission"}
            </Button>

            {effectiveOtpType === "totp" && (
              <div
                onClick={loginWithOTP}
                className="heading2 c-pointer align-self-start colorBlue"
              >
                Login with OTP <span className="colorGrey">instead</span>
              </div>
            )}
          </div>
        </div>
      </Background>
      {isKyc && returnKyc()}
    </React.Fragment>
  );

  function moveToNext() {
    setShowNext(false);
  }
};

export default loginOTPVerify;
